<template>
  <div class="flex flex-col h-full bg-white">
    <!-- Search -->
    <div class="p-4 border-b-2 border-neutral-900">
      <input
        v-model="query"
        type="text"
        placeholder="Search gyms..."
        class="w-full px-3 py-2 border-2 border-neutral-900 text-sm focus:outline-none focus:ring-2 focus:ring-slate-500"
        @input="debouncedSearch">
    </div>

    <!-- Gym List -->
    <div class="flex-1 overflow-y-auto">
      <div v-if="loading" class="p-8 text-center">
        <p class="text-xs text-slate-500 uppercase tracking-wider">
          Loading...
        </p>
      </div>

      <div v-else-if="filteredGyms.length === 0" class="p-8 text-center">
        <p class="text-xs text-slate-500 uppercase tracking-wider">
          No gyms found
        </p>
      </div>

      <div
        v-for="gym in filteredGyms"
        :key="gym.id"
        class="px-4 py-3 border-b border-slate-200 cursor-pointer transition-colors"
        :class="selectedGym?.id === gym.id ? 'bg-slate-100 border-l-4 border-l-slate-900' : 'hover:bg-slate-50'"
        @click="$emit('select', gym)">
        <div class="flex items-start justify-between">
          <div class="min-w-0 flex-1">
            <p class="text-sm font-medium text-slate-900 truncate">
              {{ gym.name }}
            </p>
            <p class="text-xs text-slate-500">
              {{ gym.city }}<span v-if="gym.state">, {{ gym.state }}</span>
            </p>
          </div>
          <span
            class="ml-2 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide border"
            :class="statusClass(gym.status)">
            {{ gym.status }}
          </span>
        </div>
        <div v-if="gym.average_rating" class="mt-1 text-xs text-slate-400">
          {{ gym.average_rating.toFixed(1) }} / 5 ({{ gym.review_count }} reviews)
        </div>
      </div>
    </div>

    <!-- Count -->
    <div class="p-3 border-t-2 border-neutral-900 bg-slate-50">
      <p class="text-xs text-slate-500 uppercase tracking-wider text-center">
        {{ filteredGyms.length }} gyms
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GymSidebar',

  props: {
    gyms: {
      type: Array,
      default: () => []
    },
    selectedGym: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  emits: ['select', 'search'],

  data() {
    return {
      query: '',
      searchTimeout: null
    }
  },

  computed: {
    filteredGyms() {
      if (!this.query) return this.gyms
      const q = this.query.toLowerCase()
      return this.gyms.filter((g) => g.name?.toLowerCase().includes(q) ||
          g.city?.toLowerCase().includes(q) ||
          g.state?.toLowerCase().includes(q))
    }
  },

  methods: {
    debouncedSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.$emit('search', this.query)
      }, 300)
    },

    statusClass(status) {
      const classes = {
        approved: 'bg-green-100 text-green-800 border-green-300',
        pending: 'bg-amber-100 text-amber-800 border-amber-300',
        rejected: 'bg-red-100 text-red-800 border-red-300'
      }
      return classes[status] || 'bg-slate-100 text-slate-800 border-slate-300'
    }
  }
}
</script>
